import { BaseObject, IBaseObjectArgs } from "../../../core/business-objects/base-object/base-object.model";

export interface IUserArgs extends IBaseObjectArgs {
    email: string;
    name?: string;
    mobile?: string;
    // address?: string;
    enabled?: boolean;
    signature?: string;
    profileImage?: string;
    lastLogin?: string;
    memberships?: Array<string>;
    passwordHash?: string;
}

const defaults = {
    name: "",
    email: "",
    mobile: "",
    // address: "",
    enabled: true,
    signature: "",
    profileImage: "",
    lastLogin: "",
    memberships: [],
    passwordHash: ""
} as IUserArgs;

export class User extends BaseObject {
    name: string;
    email: string;
    mobile: string;
    // address: string;
    enabled: boolean;
    signature: string;
    profileImage: string;
    lastLogin: string;
    memberships: Array<string>;
    passwordHash: string;

    constructor(data?: IUserArgs) {
        super({...defaults, ...data} as any);
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/user/user.model.ts